/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import DownloadCard from "../downloadpage/sub-components/DownloadCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.5rem",
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      width: "100%",
      gap: "0rem",
    },
  },
  ghost: {
    visibility: "hidden",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
    [theme.breakpoints.only("md")]: {
      width: "30%",
    },
    [theme.breakpoints.only("lg")]: {
      width: "21%",
    },
    [theme.breakpoints.only("xl")]: {
      width: "21%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "30%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 920)]: {
      width: "15%",
    },
  },
}));

const SectionOne = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.flex}>
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="What is Lighter Advisory?"
            href="https://bucket.beegru.in/customer.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Lighter Advisory Reward Program"
            href="https://bucket.beegru.in/beegru_reward_program.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Customer VAS"
            href="https://bucket.beegru.in/customer_vas.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Bulk Bookings"
            href="https://bucket.beegru.in/bulk_bookings.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Interiors"
            href="https://bucket.beegru.in/Interiors.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Construction"
            href="https://bucket.beegru.in/construction.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/pdf.svg"
            title="Big Brochure"
            href="https://bucket.beegru.in/pdf/customer_big_brochure.pdf"
          />
          <span className={classes.ghost} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionOne;
